import { render, staticRenderFns } from "./hubmaster.vue?vue&type=template&id=ba3fc702&"
import script from "./hubmaster.vue?vue&type=script&lang=js&"
export * from "./hubmaster.vue?vue&type=script&lang=js&"
import style0 from "./hubmaster.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports